export const SvelteEvents = {
  SET_AUDIO: 'set-audio',
  START_GAME: 'start-game',
  END_GAME: 'end-game',
  RESET_GAME: 'reset-game'
};

export const PhaserEvents = {
  LOAD: 'load',
  COIN_COLLECTED: 'coin-collected',
  COIN_MISSED: 'coin-missed',
  PLATFORM_SURPASSED: 'platform-surpassed',
  COLLISION: 'collision'
};
